"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var helpers_1 = require("../../../helpers");
var StatusLabel_styled_1 = require("./StatusLabel.styled");
var hooks_1 = require("../../../hooks");
var StatusLabel = function (_a) {
    var status = _a.status;
    var getStatusLabel = (0, hooks_1.useStatusLabel)();
    var statusLabel = (0, react_1.useMemo)(function () { return getStatusLabel(status); }, [status, getStatusLabel]);
    var statusIcon = (0, react_1.useMemo)(function () { return (0, helpers_1.getStatusIcon)(status, statusLabel); }, [status, statusLabel]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-2", "aria-label": "Status: ".concat(statusLabel), children: [(0, jsx_runtime_1.jsx)(StatusLabel_styled_1.StyledStatusLabel, { className: "font-style-body", status: status, children: statusLabel }), statusIcon] }));
};
exports.default = StatusLabel;
